import styles from "./Loader.module.scss"

const Loader = () => {
  return <div className={styles.loader} />
}

export default Loader
